import { Component, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import { ClientDDL, ClientInfo, DropdownItem } from "@/views/base/base.types";
import { LoginModel } from "@/views/authenticate/authenticate.types";

@Component({
  computed: {
    ...mapState("Base", [
      "clientDDL",
      "selectedClientDDL",
      "clientInfo",
      "errorMessage",
      "clientReady",
      "aspNetRolesDDL"
    ]),
    ...mapState("Authenticate", [
      "user"
    ])
  }
})
export default class BaseMixin extends Vue {
  aspNetRolesDDL!: DropdownItem<string>[];
  clientDDL!: ClientDDL[];
  clientInfo!: ClientInfo[];
  selectedClientDDL!: ClientDDL;
  errorMessage!: string;
  user!: LoginModel;
  clientReady!: boolean;

  async waitForClientReady(): Promise<ClientDDL | null> {
    let retries = 0;
    const maxRetries = 30;

    while ((!this.clientReady || !this.selectedClientDDL?.value) && retries < maxRetries) {
      await new Promise(resolve => setTimeout(resolve, 100));
      retries++;
    }

    return this.clientReady ? this.selectedClientDDL : null;
  }
}